import React from "react";

const Footer = () => {
  return (
    <footer className="page-footer font-small blue ">
      <div className="footer-copyright text-center py-3">
        © 2020 Copyright:
        <a style={{ textDecoration: "none" }} href="/">
          Hack-for-Equipments
        </a>
      </div>
    </footer>
  );
};

export default Footer;